import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";

import { hasPermission } from "./utils/permission";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Cable from "./Component/Cable";
import SalesTiles from "./OrderManagement/Sales/salestiles";
import QuotationHome from "./OrderManagement/Sales/Quotation/Home";
import SalesOrder from "./OrderManagement/Sales/SalesOrder/SalesOrder";
import SalesDashboard from "./Dashboard/SalesDashboard";
import SalesOrderDashboard from "./Dashboard/SalesOrderDashboard";
import RFQDashboard from "./Dashboard/RFQDashboard";
import BillingTiles from "./OrderManagement/Billing/BillingTiles";
import Billing from "./OrderManagement/Billing/Billing";
import BillingReview from "./OrderManagement/Billing/BillingReview";


import InquiryDashboard from "./Dashboard/EnquiryDasboard";
import ProductionDashboard from "./Dashboard/ProductionDashboard";
import ProductionOrderDashboard from "./Dashboard/ProductionOrderDashboard";

import ProductHome from "./ProcurementManagement/ProductManagement/Home";
import Product from "./ProcurementManagement/ProductManagement/Product";
import ProductConfiguration from "./ProcurementManagement/ProductManagement/ProductConfiguration";
import InspectionCharacteristics from "./ProcurementManagement/ProductManagement/inspection/Inspectioncharacteristics";
//import RFQDashboard from "./Dashboard/RFQDashboard";
import Lead from "./ProcurementManagement/ProductManagement/Lead";
import GTPConfiguration from "./ProcurementManagement/ProductManagement/GTPConfiguration";
import GTPDataUpdate from "./ProcurementManagement/ProductManagement/GTPDataUpdate";

import Login from "./Component/Login";
import PrivateLayout from "./Component/PrivateLayout";
import Layout from "./Component/Layout";


import Routing from "./Production/MasterData/routing";
import RoutingDataUpload from "./Production/MasterData/RoutingDataUpload";
import MasterData from "./Production/MasterData/MasterData";
import Workcenter from "./Production/MasterData/Workcenter";
import BOM from "./Production/MasterData/bom";
import RoutingConfig from "./Production/MasterData/routingconfig";

import Enquiry from "./OrderManagement/Sales/enquiry";
import CRM from "./OrderManagement/Sales/CustomerRelationshipManagement/CRM";
import CustomerRelationshipManagement from "./OrderManagement/Sales/CustomerRelationshipManagement/customerrelationshipmanagement";
import CustomerSupport from "./OrderManagement/Sales/CustomerRelationshipManagement/CustomerSupport";
import BomRFQ from "./OrderManagement/Sales/BomRFQ";
import VendorManagement from "./OrderManagement/businessPartner";

import MasterDataHome from "./Configuration/MasterData/Home";
import ProductMaster from "./Configuration/MasterData/ProductMaster";
import Purchasing from "./ProcurementManagement/Purchasing/Purchasing";
import PurchaseInfo from "./ProcurementManagement/Purchasing/PurchaseInfo";
import PurchaseRequest from "./ProcurementManagement/Purchasing/PurchaseRequsition";
import PurchaseOrder from "./ProcurementManagement/Purchasing/PurchaseOrder";

import Planning from "./Product Planning/Planning";
import ProductPlanning from "./Product Planning/ProductPlanning";
import GoodsAndReceipt from "./LG/Inbound/GoodsAndReceipt";
import Goodsreceipt from "./LG/Inbound/Goodsreceipt";
import Inbound from "./LG/Inbound/Inbound";
import ProductionOrder from "./Production/ShopFloor/ProductionOrder";
import PlannedOrder from "./Production/ShopFloor/PlannedOrder";
import ShopFloorControl from "./Production/ShopFloor/ShopFloorControl";
import Confirmation from "./Production/ShopFloor/Confirmation";
import GoodsRequest from "./Production/ShopFloor/GoodsRequest";
import GoodsReturn from "./Production/ShopFloor/GoodsReturn";
import ConfirmationDashboard from "./Dashboard/ConfirmationDashboard";
import StockDashboard from "./Dashboard/StockDashboard";
import ConsumptionDashboard from "./Dashboard/ConsumptionDashboard";

import GRNDashboard from "./LG/Inbound/GRNDashboard";
import LogisticsDashboard from "./Dashboard/Logisticsdashboard";
import OutboundHome from "./LG/Outbound/Home";
import Picking from "./LG/Outbound/Picking";
import Packing from "./LG/Outbound/Packing";
import OutboundDelivery from "./LG/Outbound/OutboundDelivery";
import GoodsIssue from "./LG/Outbound/GoodsIssue";
import GoodsIssueForm from "./LG/Outbound/Goodsissueform";
import Dashboard from "./LG/Outbound/Dashboard";
import ReturnReceipt from "./LG/Inbound/ReturnReceipt";
import VendorReturn from "./ProcurementManagement/Purchasing/VendorReturn";


import PurchaserequisitionView from "./ProcurementManagement/Purchasing/Docs/Purchaserequisitionview";
import QualityManagement from "./ProcurementManagement/ProductManagement/qualityManagement";
import InspectionTemplate from "./ProcurementManagement/ProductManagement/InspectionTemplate";
import InspectionCharacteristicsDataUpdate from "./ProcurementManagement/ProductManagement/InspectionCharacteristicsDataUpdate";
import GoodsRequestForm from "./Production/ShopFloor/Goodsrequestform";
import GoodsReturnForm from "./Production/ShopFloor/Goodsreturnform";
import HelpDesk from "./Configuration/MasterData/HelpDesk";




import QualityTile from "./QualityManagement/Qualitytile";
import QualityInspectionFG from "./QualityManagement/Qualityinspectionfg";
import QualityInspectionRM from "./QualityManagement/Qualityinspectionrm";
import StoreCheck from "./QualityManagement/Storecheck";
import GatePass from "./LG/Inbound/GatePass";

import QuotationView from "./OrderManagement/Sales/Quotation/QuotationView";
import PODocsView from "./ProcurementManagement/Purchasing/Docs/PODocsView";
import GoodsReceiptView from "./LG/Inbound/GoodsReceiptView";
import InspectionReportView from "./ProcurementManagement/ProductManagement/InspectionReportView";
import RawMaterialInspectionReportView from "./ProcurementManagement/ProductManagement/RawMaterialInspectionReportView";
import JobOrderView from "./Production/ShopFloor/JobOrder";
import BatchList from "./LG/Inventory Management/BatchList";
import VendorReturnForm from "./ProcurementManagement/Purchasing/Vendorreturnform";
import Pegging from "./Product Planning/Pegging";
import ReworkOrder from "./Production/ShopFloor/ReworkOrder";
import AuditCalendar from "./QualityManagement/AuditCalendar";
import Checklist from "./OrderManagement/Sales/Checklist";
import FinanceTile from "./Finance/AccountsPayable/FinanceTile";
import BankCommunicationTile from "./Finance/BankCommunication/BankCommunicationTile";
import BudgetPlanningTile from "./Finance/BudgetPlanning/BudgetPlanningTile";
import BudgetPlanningForm from "./Finance/BudgetPlanning/BudgetPlanningForm";
import BankStatement from "./Finance/BankCommunication/BankStatement";
import InvoiceVerification from "./Finance/AccountsPayable/InvoiceVerification";
import SupplierPayment from "./Finance/AccountsPayable/Supplierpayment";
import LocalizationTile from "./Finance/Localization/Localizationtile";
import IndiaLocalization from "./Finance/Localization/India/Indialocalization";
import GST from "./Finance/Localization/India/Gst";
import SalesOrderView from "./OrderManagement/Sales/SalesOrder/Salesorderview";
import GatePassView from './LG/Inbound/GatepassView';
import ScanGRN from "./LG/Inbound/ScanGRN";

import Costing from "./Controlling/ProductCosting/Costing";
import ProductCosting from "./Controlling/ProductCosting/ProductCosting";
import ActivityRate from "./Controlling/ProductCosting/ActivityRate";
import LabCalibrationStandard from "./QualityManagement/LabCalibrationStandard";
import LabEquipment from "./QualityManagement/LabEquipment";
import BatchTree from "./LG/Inventory Management/BatchTree";
import InventoryManagement from "./LG/Inventory Management/Inventory";
import AssetsTile from "./Finance/AssetsManagement/AssetsTile";
import AssetMaster from "./Finance/AssetsManagement/AssetMaster";
import AssetReport from "./Finance/AssetsManagement/AssetReport";
import GL from "./Finance/GeneralLedger/Gl";
import AccountPosting from "./Finance/GeneralLedger/AccountPosting";
import GstReport from "./Finance/Localization/India/GSTReport";
import PaymentRun from "./Finance/AccountsReceivable/PaymentRun";
import Accountsreceivable from "./Finance/AccountsReceivable/Accountsreceivable";
import UserManagementHome from "./UserManagement/UserManagementHome";
import Role from "./UserManagement/Role";
import FinanceDashboard from "./Finance/Dashboard/Dashboard";
import CFODashboard from "./Finance/Dashboard/CFODashboard";
import CSODashboard from "./Finance/Dashboard/CSODashboard";
import PayablesDashboard from "./Finance/Dashboard/PayablesDashboard";
import AccountsReceivableDashboard from "./Finance/Dashboard/AccountsReceivableDashboard";
import PlanningBlock from "./Product Planning/PlanningBlock";
import TermsConditionsConfig from "./Configuration/MasterData/TermsConditionsConfig";
import COODashboard from "./Finance/Dashboard/COODashboard";

import LocationHome from "./Location/LocationHome";
import LocationMaster from "./Location/LocationMaster";
import Putaway from "./LG/Inbound/Putaway"
import ExchangeRate from "./Finance/Localization/ExchangeRate";
import OutboundDeliveryform from "./LG/Outbound/Outbounddeliveryform";
import Custom from "./ProcurementManagement/Purchasing/Custom";
import CreateUser from "./UserManagement/Createuser";
import PlanningLog from "./Product Planning/PlanningLog";
import OrderTree from "./Product Planning/OrderTree"
import PhysicalInventory from "./LG/Inventory Management/PhysicalInventory";
import Variance from "./Finance/GeneralLedger/Variance";
import Inventory from "./LG/Inventory Management/InventoryDashboard";
import UserManualTiles from "./Configuration/UserManual/UserManualTiles";
import UserManual from "./Configuration/UserManual/UserManual";
import QualityMasterData from "./QualityManagement/Qualitymasterdata"; // adjust the relative path from wherever your routes file lives
import Scheduling from "./Product Planning/Scheduling";


// Opens a tile's page only if the user's role grants that tile (admin /
// Full Access are handled inside hasPermission, same as every other guard here).
const Gate = ({ id, children }) =>
  (hasPermission(id, "view") || hasPermission(id, "create"))
    ? children
    : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />;

function AppContent() {
  const location = useLocation();


  React.useEffect(() => {
    if (location.state?.error) {
      toast.error(location.state.error);
    }
  }, [location]);

  const getUserRole = () => {
    try {
      return JSON.parse(localStorage.getItem("user"))?.role;
    } catch {
      return null;
    }
  };
  const isAdmin = getUserRole() === "admin";

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" />} />

        <Route element={<PrivateLayout />}>

          <Route path="/home" element={<Cable />} />

          {/* SALES */}
          <Route path="/cable/sales" element={<SalesTiles />} />

          <Route path="/cable/billing" element={<BillingTiles />} />

          <Route path="/cable/billing/billing" element={
            (hasPermission("BILLING", "view") || hasPermission("BILLING_CREATE", "view") || hasPermission("BILLING_CREATE", "create"))
              ? <Billing />
              : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
          }
          />
          <Route path="/cable/billing/review" element={
            hasPermission("BILLING_REVIEW", "view")
              ? <BillingReview />
              : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
          }
          />

          {/* CRM MODULE */}

          <Route
            path="/cable/sales/crm"
            element={
              (hasPermission("CRM", "view") || hasPermission("SALES_CRM", "view") || hasPermission("SALES_CRM", "create"))
                ? <CRM />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/sales/customer-relationship"
            element={
              hasPermission("CUSTOMER_RELATIONSHIP", "view")
                ? <CustomerRelationshipManagement />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/sales/customer-support"
            element={
              (hasPermission("CUSTOMER_SUPPORT", "view") || hasPermission("SALES_CUSTOMER_SUPPORT", "view") || hasPermission("SALES_CUSTOMER_SUPPORT", "create"))
                ? <CustomerSupport />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/sales/enquiry"
            element={
              (hasPermission("SALES_INQUIRY", "view") || hasPermission("SALES_INQUIRY", "create"))
                ? <Enquiry />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/sales/quotation"
            element={
              (hasPermission("SALES_QUOTATION", "view") || hasPermission("SALES_QUOTATION", "create"))
                ? <QuotationHome />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/sales/sales-order"
            element={
              (hasPermission("SALES_ORDER", "view") || hasPermission("SALES_ORDER", "create"))
                ? <SalesOrder />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route path="/cable/sales/dashboard" element={<SalesDashboard />} />
          {/* <Route path="/cable/sales/sales-order-dashboard" element={<SalesOrderDashboard />} /> */}
          {/* <Route path="/cable/sales/rfq-dashboard" element={<RFQDashboard />} /> */}
          {/* <Route path="/cable/sales/inquiry-dashboard" element={<InquiryDashboard />} /> */}

          {/* <Route
            path="/cable/sales/dashboard"
            element={
              hasPermission("SALES_DASHBOARD", "view")
                ? <SalesDashboard />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          /> */}

          <Route
            path="/cable/sales/sales-order-dashboard"
            element={
              hasPermission("SALES_ORDER_DASHBOARD", "view")
                ? <SalesOrderDashboard />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/sales/rfq-dashboard"
            element={
              hasPermission("RFQ_DASHBOARD", "view")
                ? <RFQDashboard />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/production/dashboard"
            element={<ProductionDashboard />}
          />


          <Route
            path="/cable/production/production-order-dashboard"
            element={<Gate id="SFC_PRODUCTION_ORDER_DASHBOARD"><ProductionOrderDashboard /></Gate>}
          />

          <Route
            path="/cable/production/confirmation-dashboard"
            element={<Gate id="SFC_CONFIRMATION_DASHBOARD"><ConfirmationDashboard /></Gate>}
          />


          <Route
            path="/scan-grn"
            element={<ScanGRN />}
          />

          <Route
            path="/cable/stock/dashboard"
            element={<StockDashboard />}
          />

          <Route
            path="/cable/logistics/dashboard"
            element={<LogisticsDashboard />}
          />

          <Route
            path="/cable/stock/consumption-dashboard"
            element={<Gate id="CONSUMPTION_DASHBOARD"><ConsumptionDashboard /></Gate>}
          />

          <Route
            path="/cable/sales/inquiry-dashboard"
            element={
              hasPermission("INQUIRY_DASHBOARD", "view")
                ? <InquiryDashboard />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />


          <Route path="/cable/sales/bom-rfq" element={<BomRFQ />} />

          {/* PRODUCT */}
          <Route path="/cable/product" element={<ProductHome />} />

          <Route
            path="/cable/product/product-code"
            element={
              hasPermission("PROD_CODE", "view")
                ? <Product />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/product/product-configuration/:classCodeParam"
            element={
              hasPermission("PROD_CONFIG", "view")
                ? <ProductConfiguration />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/product/inspection-characteristics"
            element={
              hasPermission("INSP_CHAR", "view")
                ? <InspectionCharacteristics />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          {/* MASTER DATA */}
          <Route path="/cable/master-data" element={<MasterData />} />

          <Route
            path="/cable/master-data/workcenter"
            element={
              hasPermission("MD_WORKCENTER", "view")
                ? <Workcenter />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/master-data/bom"
            element={
              hasPermission("MD_BOM", "view")
                ? <BOM />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/master-data/routings"
            element={
              hasPermission("MD_ROUTING", "view")
                ? <Routing />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/master-data/routing-upload"
            element={
              hasPermission("MD_ROUTING_UPLOAD", "view")
                ? <RoutingDataUpload />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/master-data/routing-configuration"
            element={
              hasPermission("MD_ROUTING_CONFIG", "view")
                ? <RoutingConfig />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          {/* CONFIG */}
          <Route path="/cable/config/master-data" element={<MasterDataHome />} />

          <Route
            path="/cable/config/master-data/product-master"
            element={
              hasPermission("PRODUCT_MASTER_DATA", "view")
                ? <ProductMaster />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          {/* BUSINESS PARTNER */}
          <Route
            path="/cable/business-partner"
            element={
              isAdmin || hasPermission("BUSINESS_PARTNER", "view")
                ? <VendorManagement />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />
          <Route
            path="/cable/procurement/vendor-return"
            element={
              hasPermission("VENDOR_RETURN", "view")
                ? <VendorReturn />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route path="/cable/vendor-return/print/:batchNumber" element={<VendorReturnForm />} />



          <Route
            path="/cable/product/lead"
            element={
              (hasPermission("LEAD", "view") || hasPermission("LEAD_TIME", "view") || hasPermission("LEAD_TIME", "create"))
                ? <Lead />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />


          <Route
            path="/cable/procurement"
            element={<Purchasing />}
          />

          <Route
            path="/cable/procurement/purchase-info"
            element={
              hasPermission("PURCHASE_INFO", "view")
                ? <PurchaseInfo />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />


          <Route path="/cable/procurement/purchase-request" element={
            (hasPermission("PURCHASE_REQ", "view") || hasPermission("PURCHASE_REQ", "create"))
              ? <PurchaseRequest />
              : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
          } />

          <Route path="/cable/procurement/purchase-order" element={
            (hasPermission("PURCHASE_ORDER", "view") || hasPermission("PURCHASE_ORDER", "create"))
              ? <PurchaseOrder />
              : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
          } />


          {/* Tile page is open to everyone; each tile checks access on click (see Planning.js) */}
          <Route path="/cable/planning" element={<Planning />} />

          <Route
            path="/cable/productplanning"
            element={
              hasPermission("PLANNING_PRODUCT", "view")
                ? <ProductPlanning />
                : <Navigate
                  to="/home"
                  state={{ error: "Access Denied. Contact Admin." }}
                />
            }
          />

          <Route
            path="/cable/inbound-process"
            element={<Inbound />}
          />
          <Route
            path="/cable/inbound/goods-receipt"
            element={<GoodsAndReceipt />}
          />

          <Route
            path="/cable/goods-receipt/goods-receipt"
            element={
              (hasPermission("INBOUND_GOODS_RECEIPT", "view") || hasPermission("INBOUND_GOODS_RECEIPT", "create"))
                ? <Goodsreceipt />
                : <Navigate
                  to="/home"
                  state={{
                    error: "Access Denied. Contact Admin."
                  }}
                />
            }
          />


          <Route
            path="/cable/inbound/return-receipt"
            element={
              (hasPermission("INBOUND_GOODS_RECEIPT", "view") || hasPermission("INBOUND_RETURN_RECEIPT", "view") || hasPermission("INBOUND_RETURN_RECEIPT", "create"))
                ? <ReturnReceipt />
                : <Navigate
                  to="/home"
                  state={{
                    error: "Access Denied. Contact Admin."
                  }}
                />
            }
          />

          {/* PRODUCTION */}

          <Route
            path="/cable/production-order"
            element={
              (
                hasPermission("SFC_PRODUCTION_ORDER", "view") ||
                hasPermission("SFC_PRODUCTION_ORDER", "create") ||
                hasPermission("SFC_PRODUCTION_ORDER", "convert")
              )
                ? <ProductionOrder />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/planned-order"
            element={
              (
                hasPermission("SFC_PLANNED_ORDER", "view") ||
                hasPermission("SFC_PLANNED_ORDER", "create") ||
                hasPermission("SFC_PLANNED_ORDER", "convert")
              )
                ? <PlannedOrder />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/cable/shop-floor-control"
            element={<ShopFloorControl />}
          />

          <Route
            path="/cable/productionscheduling"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/cable/material-config"
            element={<Gate id="MATERIAL_CONFIG"><Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout></Gate>}
          />

          <Route
            path="/controlling/IO"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/controlling/ca"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/cable/warehouse"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/cable/pocket-margin"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/cable/rfq-automation"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/cable/vst"
            element={
              <Layout>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <h2 style={{ color: "#d93025", marginBottom: "8px" }}>
                    Access Restricted
                  </h2>
                  <p style={{ color: "#555", fontSize: "15px" }}>
                    You do not have permission to view this page. Please
                    contact your administrator.
                  </p>
                </div>
              </Layout>
            }
          />

          <Route
            path="/cable/confirmation"
            element={
              (
                hasPermission("SFC_CONFIRMATION", "view") ||
                hasPermission("SFC_CONFIRMATION", "create") ||
                hasPermission("SFC_CONFIRMATION", "convert")
              )
                ? <Confirmation />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/cable/goods-request"
            element={
              (
                hasPermission("SFC_GOODS_REQUEST", "view") ||
                hasPermission("SFC_GOODS_REQUEST", "edit") ||
                hasPermission("SFC_GOODS_REQUEST", "convert")
              )
                ? <GoodsRequest />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/cable/goods-return"
            element={
              (hasPermission("PRODUCTION_ORDER", "view") || hasPermission("SFC_GOODS_RETURN", "view") || hasPermission("SFC_GOODS_RETURN", "create"))
                ? <GoodsReturn />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/cable/inbound/grn-dashboard"
            element={
              (hasPermission("INBOUND_GRN_DASHBOARD", "view") || hasPermission("INBOUND_GR_DASHBOARD", "view") || hasPermission("INBOUND_GR_DASHBOARD", "create"))
                ? <GRNDashboard />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />


          <Route
            path="/cable/outbound-process"
            element={<OutboundHome />}
          />

          <Route
            path="/cable/outbound-process/picking"
            element={
              hasPermission("OUTBOUND_PICKING", "view")
                ? <Picking />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/cable/productplanning/pegging"
            element={
              (hasPermission("OUTBOUND_PICKING", "view") || hasPermission("PLANNING_PEGGING", "view") || hasPermission("PLANNING_PEGGING", "create"))
                ? <Pegging />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/inspection-template/:inspectionNumber"
            element={<InspectionTemplate />}
          />

          <Route
            path="/cable/outbound-process/packing"
            element={
              hasPermission("OUTBOUND_PACKING", "view")
                ? <Packing />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />
          <Route
            path="/cable/outbound-process/outbound-delivery"
            element={
              hasPermission("OUTBOUND_DELIVERY", "view")
                ? <OutboundDelivery />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />
          <Route
            path="/cable/outbound-process/goods-issue"
            element={
              hasPermission("OUTBOUND_GOODS_ISSUE", "view")
                ? <GoodsIssue />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />

          <Route
            path="/cable/outbound-process/dashboard"
            element={
              hasPermission("OUTBOUND_DASHBOARD", "view")
                ? <Dashboard />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />


          <Route
            path="/cable/product/quality-management"
            element={
              hasPermission("QUALITY_MANAGEMENT", "view")
                ? <QualityManagement />
                : (
                  <Navigate
                    to="/home"
                    state={{ error: "Access Denied. Contact Admin." }}
                  />
                )
            }
          />


          <Route
            path="/quotation/:rfqId"
            element={<QuotationView />}
          />

          <Route
            path="/job-order/:orderNo"
            element={<JobOrderView />}
          />

          <Route path="/po-docs/:poId" element={<PODocsView />} />

          <Route
            path="/goods-receipt-view/:grnNo"
            element={<GoodsReceiptView />}
          />

          <Route
            path="/inspection-report/:inspectionNo"
            element={<InspectionReportView />}
          />

          <Route
            path="/raw-material-inspection-report/:inspectionNo"
            element={<RawMaterialInspectionReportView />}
          />


          {/* QUALITY */}
          <Route path="/cable/quality" element={<QualityTile />} />

          {/* Quality Inspection split into 3 screens — all share the one QM_INSPECTION
              permission because the backend is a single QUALITY_INSPECTION module. */}
          <Route
            path="/quality/inspection-fg"
            element={
              ((hasPermission("QM_INSPECTION", "view") || hasPermission("QM_INSPECTION_FG", "view") || hasPermission("QM_INSPECTION_FG", "create")) || (hasPermission("QM_INSPECTION", "create") || hasPermission("QM_INSPECTION_FG", "create")))
                ? <QualityInspectionFG />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/quality/inspection-rm"
            element={
              (hasPermission("QM_INSPECTION", "view") || hasPermission("QM_INSPECTION", "create"))
                ? <QualityInspectionRM />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/quality/store-check"
            element={
              ((hasPermission("QM_INSPECTION", "view") || hasPermission("QM_STORE_CHECK", "view") || hasPermission("QM_STORE_CHECK", "create")) || (hasPermission("QM_INSPECTION", "create") || hasPermission("QM_STORE_CHECK", "create")))
                ? <StoreCheck />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          {/* old bookmark → RM screen */}
          <Route path="/quality/inspection" element={<Navigate to="/quality/inspection-rm" replace />} />

          <Route
            path="/cable/product/inspection-characteristics-data-update"
            element={
              hasPermission("INSP_CHAR_DATA_UPDATE", "view")
                ? <InspectionCharacteristicsDataUpdate />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />


          <Route
            path="/cable/product/gtp-configuration"
            element={
              hasPermission("GTP_CONFIGURATION", "view")
                ? <GTPConfiguration />
                : (
                  <Navigate
                    to="/home"
                    state={{ error: "Access Denied. Contact Admin." }}
                  />
                )
            }
          />

          <Route
            path="/cable/product/gtp-data-update"
            element={
              hasPermission("GTP_DATA_UPDATE", "view")
                ? <GTPDataUpdate />
                : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
            }
          />

          <Route
            path="/cable/batch-list"
            element={<Gate id="SFC_BATCH_LIST"><BatchList /></Gate>}
          />




          <Route
            path="/shopfloor/goods-request-form/:requestNo"
            element={<GoodsRequestForm />}
          />
          <Route
            path="/shopfloor/goods-return-form/:returnNo"
            element={<GoodsReturnForm />}
          />
          <Route
            path="/outbound/goods-issue-form/:issueNo"
            element={<GoodsIssueForm />}
          />

          <Route
            path="/cable/help-desk"
            element={<Gate id="HELP_DESK"><HelpDesk /></Gate>}
          />


          <Route
            path="/cable/inbound/gate-pass"
            element={
              (hasPermission("INBOUND_GATE_PASS", "view") || hasPermission("INBOUND_GATE_PASS", "create"))
                ? <GatePass />
                : (
                  <Navigate
                    to="/home"
                    state={{ error: "Access Denied. Contact Admin." }}
                  />
                )
            }
          />

          <Route
            path="/rework-order"
            element={
              (
                hasPermission("SFC_REWORK_ORDER", "view") ||
                hasPermission("SFC_REWORK_ORDER", "convert")
              )
                ? <ReworkOrder />
                : (
                  <Navigate
                    to="/home"
                    state={{
                      error: "Access Denied. Contact Admin."
                    }}
                  />
                )
            }
          />
          <Route
            path="/cable/quality/audit-calendar"
            element={<Gate id="AUDIT_CALENDAR"><AuditCalendar /></Gate>}
          />


          <Route
            path="/cable/sales/checklist"
            element={<Gate id="SALES_CHECKLIST"><Checklist /></Gate>}
          />


          <Route path="/finance" element={<FinanceTile />} />

          {/* BANK RECONCILIATION */}
          <Route path="/finance/bank-communication" element={<BankCommunicationTile />} />
          <Route path="/finance/bank-communication/bank-statement" element={<BankStatement />} />

          {/* BUDGET PLANNING */}
          <Route path="/finance/budget-planning" element={<BudgetPlanningTile />} />
          <Route path="/finance/budget-planning/entry" element={<Gate id="BUDGET_PLANNING"><BudgetPlanningForm /></Gate>} />

          <Route
            path="/finance/invoice-verification"
            element={<Gate id="INVOICE_VERIFICATION"><InvoiceVerification /></Gate>}
          />

          <Route path="/sales-order/:soId" element={<SalesOrderView />} />

          <Route path="/gatepass-view/:gatePassNo" element={<GatePassView />} />

          <Route path="/finance/supplier-payment" element={<Gate id="SUPPLIER_PAYMENT"><SupplierPayment /></Gate>} />

          <Route path="/finance/localization" element={<LocalizationTile />} />
          <Route path="/finance/localization/india" element={<IndiaLocalization />} />
          <Route path="/finance/localization/india/gst" element={<GST />} />
        </Route>

        <Route path="/controlling/product-costing" element={<Costing />} />
        <Route path="/controlling/product-costing/product-costing" element={<Gate id="PRODUCT_COSTING"><ProductCosting /></Gate>} />
        <Route path="/controlling/product-costing/activity-rate" element={<Gate id="ACTIVITY_RATE"><ActivityRate /></Gate>} />






        <Route
          path="/cable/procurement/purchase-request/view/:prNo"
          element={<PurchaserequisitionView />}
        />

        <Route
          path="/quality/lab-calibration-standard"
          element={
            hasPermission("LAB_CALIBRATION_STANDARD", "view")
              ? <LabCalibrationStandard />
              : <Navigate
                to="/home"
                state={{ error: "Access Denied. Contact Admin." }}
              />
          }
        />

        <Route
          path="/quality/lab-equipment"
          element={
            hasPermission("LAB_EQUIPMENT", "view")
              ? <LabEquipment />
              : <Navigate
                to="/home"
                state={{ error: "Access Denied. Contact Admin." }}
              />
          }
        />

        <Route path="/cable/production/batch-tree" element={<Gate id="SFC_BATCH_TREE"><BatchTree /></Gate>} />
        <Route path="/finance/assets" element={<AssetsTile />} />
        <Route path="/finance/assets/asset-master" element={<AssetMaster />} />
        <Route path="/finance/assets/asset-report" element={<AssetReport />} />
        <Route path="/finance/gl" element={<GL />} />
        <Route path="/finance/gl/account-posting" element={<Gate id="GL_ACCOUNT_POSTING"><AccountPosting /></Gate>} />
        <Route path="/finance/localization/gst" element={<GstReport />} />


        <Route path="/cable/inventory-management" element={<InventoryManagement />} />
        <Route path="/finance/account-receivable/payment-run" element={<Gate id="PAYMENT_RUN"><PaymentRun /></Gate>} />
        <Route path="/finance/ar" element={<Accountsreceivable />} />
        <Route
          path="/finance/dashboard"
          element={
            <FinanceDashboard
              moduleName="Management Dashboard"
              title="Management Dashboards"
              subtitle="Overview of management dashboards."
            />
          }
        />
        <Route path="/finance/dashboard/cfo-dashboard" element={<Gate id="CFO_DASHBOARD"><CFODashboard /></Gate>} />
        <Route path="/finance/dashboard/cso-dashboard" element={<Gate id="CSO_DASHBOARD"><CSODashboard /></Gate>} />
        <Route path="/finance/dashboard/payables-dashboard" element={<Gate id="PAYABLES_DASHBOARD"><PayablesDashboard /></Gate>} />
        <Route path="/finance/dashboard/receivables-dashboard" element={<Gate id="AR_DASHBOARD"><AccountsReceivableDashboard /></Gate>} />
        
         <Route
          path="/finance/dashboard/finance-dashboard"
          element={
            <FinanceDashboard
              moduleName="Finance Dashboard"
              title="Finance Dashboards"
              subtitle="Overview of finance dashboards."
            />
          }
        />

        <Route path="/cable/user" element={
          hasPermission("USER_MANAGEMENT", "view")
            ? <UserManagementHome />
            : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
        } />
        <Route path="/cable/user/create-role" element={
          hasPermission("USER_MANAGEMENT", "view")
            ? <Role />
            : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
        } />
       
        <Route
          path="/cable/planning-block"
          element={
            hasPermission("PLANNING_BLOCK", "view")
              ? <PlanningBlock />
              : <Navigate
                to="/home"
                state={{ error: "Access Denied. Contact Admin." }}
              />
          }
        />

        <Route
          path="/cable/config/master-data/terms-conditions"
          element={<Gate id="TERMS_CONFIG"><TermsConditionsConfig /></Gate>}
        />

        <Route
          path="/finance/dashboard/coo-dashboard"
          element={<Gate id="COO_DASHBOARD"><COODashboard /></Gate>}
        />

        {/* LOCATION */}
        <Route path="/cable/location" element={<Gate id="LOCATION"><LocationHome /></Gate>} />
        <Route path="/cable/location/location-master" element={<LocationMaster />} />

        <Route path="/cable/inbound/put-away" element={<Gate id="INBOUND_PUT_AWAY"><Putaway /></Gate>} />
        <Route path="/cable/localization/exchange-rate" element={<Gate id="EXCHANGE_RATE"><ExchangeRate /></Gate>} />
        <Route path="/cable/logistics/outbound-delivery-form/:odId" element={<OutboundDeliveryform />} />
        <Route path="/cable/procurement/custom" element={<Gate id="PURCHASE_CUSTOM"><Custom /></Gate>} />
        <Route path="/cable/user/create-user" element={
          hasPermission("USER_MANAGEMENT", "view")
            ? <CreateUser />
            : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
        } />
        <Route path="/cable/productplanning/planning-log" element={<Gate id="PLANNING_LOG"><PlanningLog /></Gate>} />
        <Route path="/cable/productplanning/order-tree" element= {<OrderTree/>}/>
        <Route path="/cable/inventory/physical-inventory" element={<Gate id="INVENTORY_PHYSICAL"><PhysicalInventory /></Gate>} />
        <Route path="/finance/gl/variance" element={<Gate id="GL_VARIANCE"><Variance /></Gate>} />
        <Route path="/cable/inventory/inventory" element={<Gate id="INVENTORY_DASHBOARD"><Inventory /></Gate>} />

        <Route path="/cable/config/user-manual" element={<UserManualTiles />} />
        <Route path="/cable/config/user-manual/manage" element={<Gate id="USER_MANUAL_UPDATE"><UserManual /></Gate>} />
        <Route path="/cable/quality/master-data" element={<QualityMasterData />} />
        <Route
  path="/cable/productplanning/scheduling"
  element={
    (hasPermission("PLANNING_PRODUCT", "view") || hasPermission("SALES_SCHEDULING", "view") || hasPermission("SALES_SCHEDULING", "create"))
      ? <Scheduling />
      : <Navigate to="/home" state={{ error: "Access Denied. Contact Admin." }} />
  }
/>


        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </>
  );
}



function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;